import _map from 'lodash/map';
import API from '../index';
import { Country } from '../../types/common';
import { transformKeyToCamelCase } from '../../utils/helpers';

const getCountries = async (): Promise<Country[]> => {
  const { resources } = await API.get('/countries');
  return _map(resources, transformKeyToCamelCase) as Country[];
};

export default getCountries;
